import { ErrorMessage, Field, useFormikContext } from "formik";
import { Col, FormGroup, Label, Row } from "reactstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { DateTime } from "luxon";

const TitleAndClientSection = () => {
  const { values, setFieldValue } = useFormikContext<any>();

  return (
    <>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Title</Label>
            <Field
              name="title"
              type="text"
              className="form-control"
              placeholder="title"
            />
            <ErrorMessage
              name="title"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Description</Label>
            <Field
              name="description"
              type="text"
              className="form-control"
              placeholder="description"
            />
            <ErrorMessage
              name="description"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
      <Row>
        <Col>
          <FormGroup>
            <Label check>Slug</Label>
            <div
              style={{
                display: "flex",
                border: "1px solid #dee2e6",
                borderRadius: "0.375rem",
              }}
              className="flex"
            >
              <span
                id="basic-addon3"
                style={{ borderRadius: 0, border: 0, fontSize: "14px" }}
                className="input-group-text"
              >
                https://www.start-smiling.co.uk/blog/
              </span>
              <Field
                name="slug"
                className="form-control"
                type="text"
                style={{ borderRadius: 0, border: "none" }}
                placeholder="slug"
              />
            </div>
            <ErrorMessage
              name="slug"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>

      <Row>
        <Col>
          <FormGroup>
            <Label check>Schedule Date & Time (UK Standard time)</Label>
            <DatePicker
              selected={
                values.scheduledDate
                  ? new Date(values.scheduledDate) // This will display in your local browser time (PKT if in Pakistan)
                  : null
              }
              onChange={(date: Date | null) => {
                if (date) {
                  // Convert picked PKT date/time → UTC ISO string
                  const utcISOString = DateTime.fromJSDate(date, {
                    zone: "Europe/London",
                  })
                    .toUTC()
                    .toISO();
                  setFieldValue("scheduledDate", utcISOString);
                } else {
                  setFieldValue("scheduledDate", "");
                }
              }}
              showTimeSelect
              timeFormat="HH:mm"
              timeIntervals={15}
              dateFormat="yyyy-MM-dd HH:mm"
              className="form-control w-100"
              placeholderText="Select date and time"
              calendarClassName="rdp-cal"
            />
            <ErrorMessage
              name="scheduledDate"
              component="span"
              className="text-danger"
            />
          </FormGroup>
        </Col>
      </Row>
    </>
  );
};

export default TitleAndClientSection;
